/* Alarie - de donde leer el scroll.

   En Horizon la pagina NO hace scroll en la ventana: hay un contenedor
   (.page-wrapper) con overflow:auto y es el que se mueve. Consecuencias:
     - window.scrollY vale siempre 0
     - el evento 'scroll' de ese contenedor no burbujea a window ni a document,
       tampoco en fase de captura
   Asi que hay que enganchar el listener al contenedor de verdad. */
(function () {
  'use strict';
  if (window.AlarieScroll) return;

  function scrollable(el) {
    if (!el || el.nodeType !== 1) return false;
    var ov = window.getComputedStyle(el).overflowY;
    return (ov === 'auto' || ov === 'scroll' || ov === 'overlay') && el.scrollHeight > el.clientHeight + 8;
  }

  function container(from) {
    var el = (from || document.body).parentElement;
    while (el && el !== document.documentElement) {
      if (scrollable(el)) return el;
      el = el.parentElement;
    }
    var w = document.querySelector('.page-wrapper');
    if (scrollable(w)) return w;
    return document.scrollingElement || document.documentElement;
  }

  function on(from, fn) {
    var seen = [];
    var el = from;
    while (el && el !== document.documentElement) {
      if (scrollable(el)) seen.push(el);
      el = el.parentElement;
    }
    var w = document.querySelector('.page-wrapper');
    if (w && seen.indexOf(w) === -1) seen.push(w);
    seen.forEach(function (n) { n.addEventListener('scroll', fn, { passive: true }); });
    window.addEventListener('scroll', fn, { passive: true });
    window.addEventListener('resize', fn, { passive: true });
    return seen;
  }

  function top(el) {
    if (!el) return 0;
    if (el === document.scrollingElement || el === document.documentElement) {
      return window.scrollY || el.scrollTop || 0;
    }
    return el.scrollTop;
  }

  window.AlarieScroll = { container: container, on: on, top: top };
})();
